var icon = require('vue-svgicon')
icon.register({
  'ks-icon-job': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M43.3 47.21h12.6v12.6H43.3zM43.3 76.6h12.6v12.6H43.3z"/><path pid="1" d="M93.7 30.4H76.14a12.55 12.55 0 0 0-23.69 0H34.9a8.4 8.4 0 0 0-8.4 8.4v58.8a8.4 8.4 0 0 0 8.4 8.4h58.8a8.4 8.4 0 0 0 8.4-8.4V38.8a8.4 8.4 0 0 0-8.4-8.4zm-33.6 63h-21v-21h21zm0-29.4h-21V43h21zm4.2-25.2a4.2 4.2 0 1 1 4.2-4.2 4.2 4.2 0 0 1-4.2 4.2zm25.19 48.29h-21v-8.4h21zm0-29.39h-21v-8.39h21z"/>'
  }
})
